const GuideIdEnums = new Map();

GuideIdEnums.set('appGuide', 3);
GuideIdEnums.set('userInterest', 4);
GuideIdEnums.set('whatIsLedger', 6);
GuideIdEnums.set('homeScreenTour', 7);
GuideIdEnums.set('aiTour', 8);
GuideIdEnums.set('featureIntro', 9);
GuideIdEnums.set('gstSummary', 10);

export default GuideIdEnums;
